import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class SelectCharacter extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let keyboardInput = new Website.game.screens.KeyboardInput();
        keyboardInput.item.screen = this.item;
        this.item.requireProperty("keyboardInput", keyboardInput.item);

        this.item.requireProperty("game", null);

        this.item.requireProperty("selectedIndex", 0).addUpdate(this._getScopedCallFunctionCommand(this._selectedCharacterChanged));
        this.item.requireProperty("characters", []);
        this.item.requireProperty("state", "select").addUpdate(this._getScopedCallFunctionCommand(this._stateChanged));

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        this.ids = ["affe", "saga", "theo", "ninni", "svenne"];
        this.names = ["AFFE", "SAGA", "THEO", "NINNI", "SVENNE"];
        this.descriptions = ["VISIONÄR\nSTRATEG", "NYA TIDENS\nINVESTERARE", "KREATIV\nINNOVATÖR",  "BIOTEKNISK\nPIONJÄR", "GENIAL\nUPPFINNARE"];
    }

    _selectedCharacterChanged() {
        //console.log("_selectedCharacterChanged");

        if(Dbm.repository.getItem("site").gameMode === "arcade") {
            let currentCharacter = this.item.characters[this.item.selectedIndex];
            currentCharacter.properties.scaleX.animateValue(1.2, 0.3, 0);
            currentCharacter.properties.scaleY.animateValue(1.2, 0.3, 0);
        }
    }

    _callback_startClicked(aIndex, aEvent) {
        //console.log("_callback_startClicked");

        let maxScale = 1.5;
        let time = 0.4;

        this.item.game.playerId = this.ids[aIndex];
        this.item.game.playerIndex = aIndex;
        this.item.game.playerName = this.names[this.item.game.playerIndex];

        let currentArray = this.item.characters;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentCharacter = currentArray[i];

            if(i === aIndex) {
                
                currentCharacter.properties.scaleX.animateValue(maxScale, time, 0);
                currentCharacter.properties.scaleX.addAddionalAnimation(maxScale, 0.7, time, time);

                currentCharacter.properties.scaleY.animateValue(maxScale, time, 0);
                currentCharacter.properties.scaleY.addAddionalAnimation(maxScale, 0.7, time, time);

                currentCharacter.properties.alpha.animateValue(0, 0.2, time+0.1);
            }
            else {
                let delay = 0.1*(Math.abs(aIndex-i)-1);

                currentCharacter.properties.alpha.animateValue(0, 0.3, delay);

                if(i < aIndex) {
                    currentCharacter.properties.x.animateValue(-10, 0.3, delay);
                }
                else {
                    currentCharacter.properties.x.animateValue(10, 0.3, delay);
                }
            }
        }

        this.item.keyboardInput.active = false;
        this.item.properties.state.delayValue("outroDone", 2*time);

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    _stateChanged() {
        let currentState = this.item.state;
        if(currentState === "outroDone") {
            this.item.game.controller.changeScreen("playerInformation");
        }
    }

    prepare() {
        //console.log("prepare");

        const box = new PIXI.Graphics();
        box.beginFill(0xefe7e1);
        box.drawRect(0, 0, Website.game.Sizes.WIDTH, Website.game.Sizes.HEIGHT);
        box.endFill();
        this.item.pixiLayer.addChild(box);

        let textures = Website.game.getTextures("screens/select-character", "character");

        let currentArray = textures;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let newCharacter = new PIXI.Container();

            let animationLayer = new PIXI.Container();
            newCharacter.addChild(animationLayer);
            
            let scaleLayer = new PIXI.Container();
            animationLayer.addChild(scaleLayer);

            scaleLayer.position.x = 0.5*Website.game.Sizes.CHARACTER_WIDTH;
            scaleLayer.position.y = 0.5*Website.game.Sizes.CHARACTER_HEIGHT;

            let sprite = new PIXI.Sprite(currentArray[i]);
            scaleLayer.addChild(sprite);
            sprite.position.x = -1*0.5*Website.game.Sizes.CHARACTER_WIDTH;
            sprite.position.y = -1*0.5*Website.game.Sizes.CHARACTER_HEIGHT;

            let nameText = Dbm.getRepositoryItem("game").controller.getText(this.names[i], 16, 0x000000);

            let textAnimationLayer = new PIXI.Container();
            animationLayer.addChild(textAnimationLayer);
        
            nameText.position.x = 0.5*(Website.game.Sizes.CHARACTER_WIDTH-nameText.width);
            nameText.position.y = Website.game.Sizes.CHARACTER_HEIGHT+10;

            textAnimationLayer.addChild(nameText);

            let descriptionText = Dbm.getRepositoryItem("game").controller.getText(this.descriptions[i], 8, 0x000000, {align: "center"});

            let descriptionAnimationLayer = new PIXI.Container();
            //animationLayer.addChild(descriptionAnimationLayer);
        
            descriptionText.position.x = 0.5*(Website.game.Sizes.CHARACTER_WIDTH-descriptionText.width);
            descriptionText.position.y = Website.game.Sizes.CHARACTER_HEIGHT+10+10;

            descriptionAnimationLayer.addChild(descriptionText);

            let xIndex = i-(0.5*(currentArrayLength-1))

            let xPosition = 0.5*Website.game.Sizes.WIDTH+xIndex*(Website.game.Sizes.CHARACTER_WIDTH+10)-0.5*Website.game.Sizes.CHARACTER_WIDTH;

            newCharacter.position.set(xPosition, 0.5*(Website.game.Sizes.HEIGHT-Website.game.Sizes.CHARACTER_HEIGHT));
            newCharacter.eventMode = "static";
            newCharacter.on("pointerdown", this._callback_startClicked.bind(this, i));

            this.item.pixiLayer.addChild(newCharacter);

            let characterController = Dbm.flow.externalObject({"animationLayer": animationLayer, "textAnimationLayer": textAnimationLayer, "descriptionAnimationLayer": descriptionAnimationLayer, "scaleLayer": scaleLayer});
            this.item.addToArray("characters", characterController.item);
            characterController.addProperty("alpha", 0, "animationLayer.alpha");
            characterController.addProperty("x", 0, "animationLayer.position.x");
            characterController.addProperty("scaleX", 1, "scaleLayer.scale.x");
            characterController.addProperty("scaleY", 1, "scaleLayer.scale.y");
            characterController.addProperty("textAlpha", 0, "textAnimationLayer.alpha");
            characterController.addProperty("textY", 0, "textAnimationLayer.position.y");
            characterController.addProperty("descriptionAlpha", 0, "descriptionAnimationLayer.alpha");
            characterController.addProperty("descriptionY", 0, "descriptionAnimationLayer.position.y");
        }

        {
            let text = Dbm.getRepositoryItem("game").controller.getText("VÄLJ DIN HJÄLTE", 16, 0x000000);
        
            text.position.x = 0.5*(Website.game.Sizes.WIDTH-text.width);
            text.position.y = 20;

            this.item.pixiLayer.addChild(text);
        }
        
        
    }

    start() {
        this.item.keyboardInput.active = true;
        this.item.state = "select";

        let currentArray = this.item.characters;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentCharacter = currentArray[i];

            currentCharacter.scaleX = 1;
            currentCharacter.scaleY = 1;

            currentCharacter.alpha = 0;
            currentCharacter.properties.alpha.animateValue(1, 0.3, i*0.2);

            currentCharacter.x = -10;
            currentCharacter.properties.x.animateValue(0, 0.7, i*0.2);

            let textDelay = 0.1;
            currentCharacter.textAlpha = 0;
            currentCharacter.properties.textAlpha.animateValue(1, 0.4, i*0.2+textDelay);

            currentCharacter.textY = -10;
            currentCharacter.properties.textY.animateValue(0, 0.4, i*0.2+textDelay);

            let descriptionDelay = textDelay+0.2;
            currentCharacter.descriptionAlpha = 0;
            currentCharacter.properties.descriptionAlpha.animateValue(1, 0.7, i*0.2+descriptionDelay);

            currentCharacter.descriptionY = -5;
            currentCharacter.properties.descriptionY.animateValue(0, 0.7, i*0.2+descriptionDelay);
        }

        this._selectedCharacterChanged();
    }

    update(aTime, aDelta) {
        
    }

    stop() {
        this.item.keyboardInput.active = false;
    }

    leftInput() {
        let currentCharacter = this.item.characters[this.item.selectedIndex];
        currentCharacter.properties.scaleX.animateValue(1, 0.3, 0);
        currentCharacter.properties.scaleY.animateValue(1, 0.3, 0);

        this.item.selectedIndex = (this.item.selectedIndex+1)%5;
    }

    rightInput() {
        this._callback_startClicked(this.item.selectedIndex);
    }
}